"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.common_de_de = void 0;
function common_de_de() {
    return {
        "actions.close": "schließen",
        "actions.save": "speichern",
        "actions.cancel": "abbrechen",
        "actions.create": "erstellen",
        "actions.yes": "ja",
        "actions.no": "nein",
        "actions.dialogdismiss": "schließen",
        "actions.add": "hinzufügen",
        "actions.edit": "bearbeiten",
        "actions.delete": "löschen",
        "actions.ok": "ok",
        "actions.search": "suchen",
        "actions.reset": "zurücksetzen",
        "actions.skip": "überspringen",
        "actions.print": "drucken",
        "actions.refresh": "aktualisieren",
        "actions.select": "auswählen",
        "actions.done": "fertig",
        "actions.more": "mehr",
        "actions.enable": "aktivieren",
        "actions.disable": "deaktivieren",
        "actions.accept": "akzeptieren",
        "actions.download": "herunterladen",
        "actions.upload": "hochladen",
        "actions.showall": "alle anzeigen",
        "actions.submit": "absenden",
        "actions.addnote": "Notiz hinzufügen",
        "actions.learn": "Mehr erfahren!",
        "actions.continue": "fortfahren",
        "actions.disconnect": "trennen",
        "actions.open": "öffnen",
        "actions.donotshowagain": "Nicht mehr anzeigen!",
        "actions.import": "importieren",
        "actions.check": "überprüfen",
        "actions.openinnewwindow": "In neuem Fenster öffnen",
        "actions.restore": "Wiederherstellen",
        "errors.notfound": "Nicht gefunden",
        "errors.nodata": "Keine Daten vorhanden",
        "errors.generic": "Es ist ein unerwarteter Fehler aufgetreten",
        "errors.tryagainlater": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es später noch einmal.",
        "errors.invalidmail": "Bitte geben Sie eine gültige E-Mail Adresse ein (z.B. test@gmail.com)",
        "errors.invalidphonenumber": "Bitte geben Sie eine gültige Telefonnummer ein (z.B. +49896121247)",
        "errors.invalidurl": "Bitte geben Sie eine gültige URL ein",
        "errors.http.400": "Die Anfrage konnte nicht verarbeitet werden",
        "errors.http.401": "Sie sind nicht eingeloggt",
        "errors.http.403": "Kein Zugriff auf diese Resource",
        "errors.http.404": "Die angefragte Resource existiert nicht",
        "errors.http.409": "Die Resource existiert bereits",
        "errors.http.500": "Da ging was schief",
        "errors.http.503": "Der Dienst ist im Moment nicht verfügbar",
        "errors.unreachable.title": "Fehler",
        "errors.unreachable.message": "Das System ist momentan nicht erreichbar, bitte versuchen Sie es in wenigen Augenblicken erneut!",
        "errors.access.nottheowner": "Sie sind nicht der Besitzer dieser Resource",
        "errors.validations.validating_field": "Feld",
        "errors.validations.validation_failed_message": "Bei der Validierung Ihrer Eingaben sind Fehler aufgetreten!",
        "errors.validations.required": "erforderlich",
        "errors.validations.isalpha": "nur Kleinbuchstaben (a-z) sind erlaubt",
        "errors.validations.isemail": "muss gültige E-Mail sein",
        "errors.validations.islowercase": "nur Kleinbuchstaben (a-z) sind erlaubt",
        "errors.validations.isurlconform": "Maximal 45 Zeichen. Alle Zeichen müssen URL konform sein (a-Z 0-9 _\\-~)",
        "errors.validations.length": "muss mindestens 3 Buchstaben enthalten",
        "errors.validations.minlength": "muss eine Mindestlänge von ${requiredLength} Zeichen haben",
        "errors.validations.maxlength": "darf nicht länger als ${maxLength} Zeichen sein",
        "errors.validations.min": "muss mindestens ${min} oder größer sein",
        "errors.validations.max": "darf nicht größer als ${max} sein",
        "errors.validations.minitems": "muss mindestens ${min} Elemente enthalten",
        "errors.validations.maxitems": "darf höchstens ${max} Elemente enthalten",
        "errors.validations.isstring": "muss eine Zeichenkette sein",
        "errors.validations.isint": "muss eine Zahl sein",
        "errors.validations.isobject": "muss ein JavaScript Objekt sein",
        "errors.validations.isjsonschema7": "muss ein JSONSchema7 sein",
        "errors.validations.matches": "muss dem Muster entsprechen",
        "errors.validations.isdefined": "muss definiert sein",
        "errors.validations.pattern": "muss diesem Muster entsprechen: ${requiredPattern}",
        "errors.validations.iconerror": "muss ein valides icon sein",
        "errors.validations.invalidvalue": "muss einem der vorgeschlagenen Werte entsprechen",
        "errors.validations.enum": "muss einem dieser Werte entsprechen: ${enumValues}",
        "errors.validations.type": "muss vom Typ ${type} sein",
        "errors.user.email_already_exists": "Diese E-Mail ist bereits registriert",
        "errors.user.invalid_password_uppercasemissing": "Ungültiges Passwort: Großbuchstabe fehlt",
        "errors.user.invalid_password_lowercasemissing": "Ungültiges Passwort: Kleinbuchstabe fehlt",
        "errors.user.invalid_password_notatleast8characterslong": "Ungültiges Passwort: Bitte mindestens 8 Zeichen eingeben",
        "errors.user.invalid_password_nospecialcharacter": "Ungültiges Passwort: Bitte geben Sie ein Sonderzeichen wie ! ? # oder Leerzeichen ein",
        "errors.user.token_required": "Keinen Token erhalten",
        "errors.user.invalid_password": "Falsches Passwort",
        "errors.user.user_not_found": "Benutzer nicht gefunden",
        "errors.user.invalid_token": "Ungültiges Token",
        "errors.user.invalidjsonprofileschema": "Schema des Benutzerprofils ist nicht in validem JSON Format",
        "errors.user.notmatchingprofileschema": "Benutzerprofil entspricht nicht dem definierten Schema",
        "errors.user.noprofileschema": "Kein aktuelles JSON formatiertes Benutzerprofilschema gefunden",
        "errors.user.notalloldkeyspresentinschema": "Im neuen Schema sind nicht alle Werte des alten Schemas enthalten",
        "errors.user.newandoldtypenotmatching": "Alle vorhandenen Datentypen müssen mit den neuen übereinstimmen",
        "errors.user.creationnotallowed": "Erstellung neuer Benutzer ist nicht erlaubt.",
        "errors.invitation.missingrole": "Eine Einladung muss mindestens eine Rolle enthalten.",
        "errors.invitation.notenant": "Kein Tenant gefunden für ID: ",
        "errors.invitation.notinvitable": "Einladungen können nur für Projekte oder Firmen erstellt werden.",
        "errors.verify.email.invalid_token": "Token ist nicht valide",
        "errors.verify.email.incorrect_token": "Token ist fehlerhaft",
        "errors.verify.email.email_not_found": "Email konnte nicht gefunden werden",
        "errors.verify.email.could_not_send": "Email-Bestätigung konnte nicht versendet werden",
        "errors.file.unsplash.notoken": "Der Reseller hat keinen API Key für Unsplash.com gesetzt.",
        "errors.file.unsplash.invalidtoken": "Der Token für Unsplash.com ist nicht valide.",
        "errors.file.unsplash.limitexceeded": "Anfragelimite von Unsplash.com wurde überschritten.",
        "errors.file.unsplash.generalerror": "Bei der Anfrage auf Unsplash.com ist ein Fehler aufgetreten.",
        "errors.note.noservicetoken": "ServiceTokens können nicht zum Lesen oder Verändern von Notizen verwendent werden.",
        "errors.note.usernotfound": "Zu dieser Notiz konnte kein Benutzer gefunden werden.",
        "errors.note.onlyeditpersonal": "Es können nur persönliche Notizen bearbeitet werden.",
        "errors.note.onlyaccesspersonal": "Persönliche Notizen von Anderen können nicht betrachtet werden.",
        "errors.note.notargetidchange": "Die TargetId kann nicht verändert oder gelöscht werden.",
        "messages.errors.notinsamecompany": "Sie können nur Nachrichten an jemanden in Ihrer Firma senden!",
        "messages.errors.messagenotfound": "Nachricht konnte nicht gefunden werden.",
        "messages.errors.recipienttypenotfound": "Der folgende Empfängertype konnte nicht gefunden werden: ",
        "messages.errors.recipientnotfound": "Empfänger der Nachricht wurde nicht gefunden.",
        "messages.errors.wrongreseller": "Falscher reseller für diesen Tenant.",
        "messages.errors.isdifferentproject": "Nachricht kann nicht an andere Projekte versendet werden.",
        "messages.errors.isnotprojectmember": "Nachrichtenempfänger ist kein Projektmitglied.",
        "messages.errors.sendingnotallowed": "Nur Projekte und Benutzer dürfen Nachrichten versenden.",
        "messages.system.exportdone": "Ihr Datenexport ist abgeschlossen!",
        "messages.system.downloadexport": "Exportierte Daten herunterladen",
        "messages.system.acceptedinvitation": "hat Ihre Einladung akzeptiert.",
        "models.identifier": "Kennung",
        "models.creationdate": "Erstellungsdatum",
        "models.createdat": "Erstellt am",
        "notes.privatehint": "Private Notiz",
        "notes.private": "Privat",
        "notifications.title": "Benachrichtigungen",
        "notifications.empty": "Hier werden aktuelle Benachrichtigungen angezeigt. Im Moment gibt es nichts neues.",
        "notifications.confirmation.title": "Bestätigung",
        "notifications.warning.title": "Warnung",
        "notifications.error.title": "Fehler",
        "notifications.error.message": "Es ist ein Fehler aufgetreten!",
        "notifications.success.title": "Erfolgreich",
        "notifications.added.title": "Erfolgreich hinzugefügt.",
        "notifications.deleted.title": "Erfolgreich gelöscht.",
        "notifications.edited.title": "Erfolgreich bearbeitet.",
        "notifications.markedasdone.title": "Erfolgreich als erledigt markiert.",
        "notifications.markedasopen.title": "Erfolgreich als offen markiert.",
        "notifications.favorites.added": "Zu Favoriten hinzugefügt.",
        "notifications.favorites.removed": "Von Favoriten entfernt.",
        "nouns.images": "Bilder",
        "nouns.name": "Name",
        "nouns.description": "Beschreibung",
        "nouns.creationdate": "Erstellungsdatum",
        "nouns.qrcode": "QR Code",
        "nouns.actions": "Aktionen",
        "nouns.preview": "Vorschau",
        "nouns.details": "Details",
        "nouns.value": "Wert",
        "nouns.error": "Fehler",
        "nouns.icon": "Icon",
        "nouns.help": "Hilfe",
        "nouns.company": "Firma",
        "nouns.companyphone": "Firmentelefon",
        "pager.back": "zurück",
        "pager.next": "weiter",
        "pager.more": "mehr",
        "pager.itemsperpagelabel": "Elemente pro Seite",
        "pager.firstpagelabel": "Erste Seite",
        "pager.nextpagelabel": "Nächste Seite",
        "pager.previouspagelabel": "Vorherige Seite",
        "pager.lastpagelabel": "Letzte Seite",
        "pager.of": "von",
        "permissions.delete": "Alle Rechte entfernen",
        "permissions.assign": "Standardrechte zuweisen",
        "permissions.assigncustom": "Eigene Rechte zuweisen",
        "permissions.errors.missing": "Fehlendes Recht: ${permission}",
        "permissions.audit.read.title": "Veränderungslog einsehen",
        "permissions.cms.write.title": "CMS Seiten bearbeiten",
        "permissions.cms.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von CMS Seiten.",
        "permissions.cms.read.title": "CMS Seiten lesen",
        "permissions.cms.read.description": "Dieses Recht erlaubt das Lesen von CMS Seiten.",
        "permissions.checkin.admin.title": "Checkin App Administrator",
        "permissions.checkin.admin.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Checkin Besuchern, Apps und Konfigurationen bearbeiten.",
        "permissions.checkin.read.title": "Checkin App lesen",
        "permissions.checkin.read.description": "Dieses Recht erlaubt das Lesen von Checkin Besuchern, Apps und Konfigurationen bearbeiten.",
        "permissions.custombackoffices.write.title": "Benutzerdefinierte Backoffices bearbeiten",
        "permissions.custombackoffices.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von benutzerdefinierten Backoffice Modulen.",
        "permissions.custombackoffices.read.title": "Benutzerdefinierte Backoffices lesen",
        "permissions.custombackoffices.read.description": "Dieses Recht erlaubt das Lesen von benutzerdefinierten Backoffices.",
        "permissions.applications.read.title": "Applikationen lesen",
        "permissions.applications.read.description": "Dieses Recht erlaubt das Lesen von Applikationen.",
        "permissions.applications.write.title": "Applikationen bearbeiten",
        "permissions.applications.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Applikationen.",
        "permissions.bookedsubscriptions.write.title": "gebuchte Abonnements bearbeiten",
        "permissions.bookedsubscriptions.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von gebuchten Abonnements.",
        "permissions.calendar.read.title": "Kalender lesen",
        "permissions.calendar.read.description": "Dieses Recht erlaubt das Lesen von Kalendern.",
        "permissions.calendar.write.title": "Kalender bearbeiten",
        "permissions.calendar.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Kalendern.",
        "permissions.configuration.read.title": "Konfigurationen lesen",
        "permissions.configuration.read.description": "Dieses Recht erlaubt das Lesen von Konfigurationen.",
        "permissions.configuration.write.title": "Konfigurationen bearbeiten",
        "permissions.configuration.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Konfigurationen.",
        "permissions.configuration.admin.title": "Konfigurationen Administrator",
        "permissions.configuration.admin.description": "Dieses Recht erlaubt vollen Zugriff auf alle Konfigurationsoperationen.",
        "permissions.contacts.read.title": "Kontakte lesen",
        "permissions.contacts.read.description": "Dieses Recht erlaubt das Lesen von Kontakten.",
        "permissions.contacts.write.title": "Kontakte bearbeiten",
        "permissions.contacts.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Kontakten.",
        "permissions.contacts.admin.title": "Kontakte Administrator",
        "permissions.contacts.admin.description": "Dieses Recht erlaubt vollen Zugriff auf alle Kontaktoperationen.",
        "permissions.cronjob.read.title": "Cronjobs lesen",
        "permissions.cronjob.read.description": "Dieses Recht erlaubt das Lesen von Cronjobs.",
        "permissions.cronjob.write.title": "Cronjobs bearbeiten",
        "permissions.cronjob.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Cronjobs.",
        "permissions.data.read.title": "Daten lesen",
        "permissions.data.read.description": "Dieses Recht erlaubt das Lesen von Daten.",
        "permissions.data.write.title": "Daten bearbeiten",
        "permissions.data.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Daten.",
        "permissions.datatypes.read.title": "Datentypen lesen",
        "permissions.datatypes.read.description": "Dieses Recht erlaubt das Lesen von Datentypen.",
        "permissions.datatypes.write.title": "Datentypen bearbeiten",
        "permissions.datatypes.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Datentypen.",
        "permissions.devices.read.title": "Geräte einsehen",
        "permissions.devices.read.description": "Dieses Recht erlaubt das Einsehen von Geräten.",
        "permissions.devices.write.title": "Geräte bearbeiten",
        "permissions.devices.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Geräten.",
        "permissions.emails.read.title": "Emails lesen",
        "permissions.emails.read.description": "Dieses Recht erlaubt das Lesen von Emails.",
        "permissions.emails.write.title": "Emails schreiben",
        "permissions.emails.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Emails.",
        "permissions.emails.send.title": "Emails senden",
        "permissions.emails.send.description": "Dieses Recht erlaubt das Senden von Emails.",
        "permissions.emailtemplates.read.title": "Email Vorlagen lesen",
        "permissions.emailtemplates.read.description": "Dieses Recht erlaubt das Lesen von Email Vorlagen.",
        "permissions.emailtemplates.write.title": "Email Vorlagen bearbeiten",
        "permissions.emailtemplates.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Email Vorlagen.",
        "permissions.exporters.execute.title": "Exporter ausführen",
        "permissions.exporters.execute.description": "Dieses Recht erlaubt das Ausführen des Exporters.",
        "permissions.exporters.read.title": "Exporter einsehen",
        "permissions.exporters.read.description": "Dieses Recht erlaubt das Einsehen des Exporters.",
        "permissions.files.read.title": "Projektdateien lesen",
        "permissions.files.read.description": "Dieses Recht erlaubt das Lesen von Projektdateien.",
        "permissions.files.write.title": "Projektdateien bearbeiten",
        "permissions.files.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Projektdateien.",
        "permissions.forms.read.title": "Formulare lesen",
        "permissions.forms.read.description": "Dieses Recht erlaubt das Lesen von Formularen.",
        "permissions.forms.write.title": "Formulare bearbeiten",
        "permissions.forms.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Formularen.",
        "permissions.forms.admin.title": "Formular Administrator",
        "permissions.forms.admin.description": "Dieses Recht erlaubt vollen Zugriff auf alle Formularoperationen.",
        "permissions.importers.execute.title": "Importer ausführen",
        "permissions.importers.execute.description": "Dieses Recht erlaubt das Ausführen des Importers.",
        "permissions.importers.read.title": "Importer einsehen",
        "permissions.importers.read.description": "Dieses Recht erlaubt das Einsehen des Importers.",
        "permissions.internationalization.read.title": "Internationalisierungen lesen",
        "permissions.internationalization.read.description": "Dieses Recht erlaubt das Lesen von Internationalisierungen.",
        "permissions.internationalization.write.title": "Internationalisierungen bearbeiten",
        "permissions.internationalization.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Internationalisierungen.",
        "permissions.messages.read.title": "Nachrichten lesen",
        "permissions.messages.read.description": "Dieses Recht erlaubt das Lesen von Nachrichten.",
        "permissions.messages.write.title": "Nachrichten bearbeiten",
        "permissions.messages.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Nachrichten.",
        "permissions.mailinglist.read.title": "Mailinglisten lesen",
        "permissions.mailinglist.read.description": "Dieses Recht erlaubt das Lesen von Mailinglisten.",
        "permissions.mailinglist.write.title": "Mailinglisten bearbeiten",
        "permissions.mailinglist.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Mailinglisten.",
        "permissions.mailingchannel.read.title": "Mailingkanäle einsehen",
        "permissions.mailingchannel.read.description": "Dieses Recht erlaubt das Einsehen von Mailingkanälen.",
        "permissions.mailingchannel.write.title": "Mailingkanäle bearbeiten",
        "permissions.mailingchannel.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Mailingkanälen.",
        "permissions.mailingdeliverable.read.title": "Mailingdeliverables lesen",
        "permissions.mailingdeliverable.read.description": "Dieses Recht erlaubt das Lesen von Mailingdeliverables.",
        "permissions.mailingdeliverable.write.title": "Mailingdeliverables bearbeiten",
        "permissions.mailingdeliverable.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Mailingdeliverables.",
        "permissions.optin.write.title": "Optins bearbeiten",
        "permissions.optin.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Optins.",
        "permissions.orders.read.title": "Bestellungen lesen",
        "permissions.orders.read.description": "Dieses Recht erlaubt das Lesen von Bestellungen.",
        "permissions.orders.write.title": "Bestellungen bearbeiten",
        "permissions.orders.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Bestellungen.",
        "permissions.permission.read.title": "Rechte einsehen",
        "permissions.permission.read.description": "Dieses Recht erlaubt das Einsehen von Rechten.",
        "permissions.permission.write.title": "Rechte bearbeiten",
        "permissions.permission.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Rechten.",
        "permissions.products.read.title": "Produkte einsehen",
        "permissions.products.read.description": "Dieses Recht erlaubt das Einsehen von Produkten.",
        "permissions.products.write.title": "Produkte bearbeiten",
        "permissions.products.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Produkten.",
        "permissions.datatemplates.write.title": "Daten Vorlagen bearbeiten",
        "permissions.datatemplates.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Daten Vorlagen.",
        "permissions.shoppingcarts.read.title": "Einkaufswägen einsehen",
        "permissions.shoppingcarts.read.description": "Dieses Recht erlaubt das Lesen von Einkaufswägen.",
        "permissions.shoppingcarts.write.title": "Einkaufswägen bearbeiten",
        "permissions.shoppingcarts.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Einkaufswägen.",
        "permissions.suppliers.read.title": "Zulieferer einsehen",
        "permissions.suppliers.read.description": "Dieses Recht erlaubt das Einsehen von Zulieferern.",
        "permissions.suppliers.write.title": "Zulieferer bearbeiten",
        "permissions.suppliers.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Zulieferern.",
        "permissions.tasks.execute.title": "Aufgaben ausführen",
        "permissions.tasks.execute.description": "Dieses Recht erlaubt das Ausführen von Aufgaben",
        "permissions.tasks.read.title": "Aufgaben lesen",
        "permissions.tasks.read.description": "Dieses Recht erlaubt das Lesen von Aufgaben.",
        "permissions.tasks.write.title": "Aufgaben bearbeiten",
        "permissions.tasks.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Aufgaben.",
        "permissions.tenant.admin.title": "Admin",
        "permissions.tenant.admin.description": "Dieses Recht erlaubt vollen Zugriff auf alle Daten und Module eines Projektes.",
        "permissions.tenant.read.title": "Mandanten (Projekte/Firmen) lesen",
        "permissions.tenant.read.description": "Dieses Recht erlaubt das Lesen von Mandanten (Projekte/Firmen).",
        "permissions.tenant.write.title": "Mandanten (Projekte/Firmen) bearbeiten",
        "permissions.tenant.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Mandanten (Projekte/Firmen).",
        "permissions.company.read.title": "Firma einsehen",
        "permissions.company.read.description": "Dieses Recht erlaubt das Einsehen der Firma.",
        "permissions.company.write.title": "Firma bearbeiten",
        "permissions.company.write.description": "Dieses Recht erlaubt das Löschen und Bearbeiten der Firma.",
        "permissions.project.read.title": "Projekt lesen",
        "permissions.project.read.description": "Dieses Recht erlaubt das Lesen des Projekts.",
        "permissions.project.write.title": "Projekt bearbeiten",
        "permissions.project.write.description": "Dieses Recht erlaubt das Löschen und Bearbeiten des Projekts.",
        "permissions.users.read.title": "Benutzer lesen",
        "permissions.users.read.description": "Dieses Recht erlaubt das Lesen von Benutzern.",
        "permissions.users.write.title": "Internationalisierungen Benutzer",
        "permissions.users.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Benutzern.",
        "permissions.workflow.execute.title": "Workflows ausführen",
        "permissions.workflow.execute.description": "Dieses Recht erlaubt das Ausführen von Workflows.",
        "permissions.workflow.read.title": "Workflows lesen",
        "permissions.workflow.read.description": "Dieses Recht erlaubt das Lesen von Workflows.",
        "permissions.workflow.write.title": "Workflows bearbeiten",
        "permissions.workflow.write.description": "Dieses Recht erlaubt das Erstellen, Löschen und Bearbeiten von Workflows.",
        "permissions.todotemplate.write": "Aufgaben Vorlage bearbeiten",
        "states.active": "aktiv",
        "states.inactive": "inaktiv",
        "states.activated": "aktiviert",
        "types.primitives.boolean": "richtig/falsch",
        "types.primitives.string": "Zeichenkette",
        "types.primitives.number": "Zahl",
        "types.customtype.singular": "Projektspezifischer Typ",
        "types.customtype.plural": "Projektspezifische Typen",
        "types.customers.singular": "Kunde",
        "types.customers.plural": "Kunden",
        "types.applications.singular": "Anwendung",
        "types.applications.plural": "Anwendungen",
        "types.auditlog_records.singular": "Audit-Log",
        "types.auditlog_records.plural": "Audit-Logs",
        "types.subscriptions_booked.singular": "Gebuchtes Abonnement",
        "types.subscriptions_booked.plural": "Gebuchte Abonnements",
        "types.calendars.singular": "Kalender",
        "types.calendars.plural": "Kalender",
        "types.calendarentries.singular": "Termin",
        "types.calendarentries.plural": "Termine",
        "types.cmspages.singular": "CMS Seite",
        "types.cmspages.plural": "CMS Seiten",
        "types.companies.singular": "Firma",
        "types.companies.plural": "Firmen",
        "types.configurations.singular": "Konfiguration",
        "types.configurations.plural": "Konfigurationen",
        "types.contact_customfields.singular": "Benutzerdefiniertes Kontaktfeld",
        "types.contact_customfields.plural": "Benutzerdefinierte Kontaktfelder",
        "types.contacts.singular": "Kontakt",
        "types.contacts.plural": "Kontakte",
        "types.counters.singular": "Zähler",
        "types.counters.plural": "Zähler",
        "types.countries.singular": "Land",
        "types.countries.plural": "Länder",
        "types.cronjobs.singular": "Geplante Aufgabe",
        "types.cronjobs.plural": "Geplante Aufgaben",
        "types.custombackoffices.singular": "Projektspezifisches Backoffice",
        "types.custombackoffices.plural": "Projektspezifische Backoffices",
        "types.dashboards.singular": "Dashboard",
        "types.dashboards.plural": "Dashboards",
        "types.datatypes.singular": "Datentyp",
        "types.datatypes.plural": "Datentypen",
        "types.data.singular": "Daten",
        "types.data.plural": "Daten",
        "types.device_registrations.singular": "Geräteregistrierung",
        "types.device_registrations.plural": "Geräteregistrierungen",
        "types.devices.singular": "Gerät",
        "types.devices.plural": "Geräte",
        "types.emaillayouts.singular": "Email Layout",
        "types.emaillayouts.plural": "Email Layouts",
        "types.emailtemplates.singular": "Email Vorlage",
        "types.emailtemplates.plural": "Email Vorlagen",
        "types.emails.singular": "Email",
        "types.emails.plural": "Emails",
        "types.files.singular": "Datei",
        "types.files.plural": "Dateien",
        "types.forms.singular": "Formular",
        "types.forms.plural": "Formulare",
        "types.invitations.singular": "Einladung",
        "types.invitations.plural": "Einladungen",
        "types.languages.singular": "Sprache",
        "types.languages.plural": "Sprachen",
        "types.locales.singular": "Gebietsschema",
        "types.locales.plural": "Gebietsschemas",
        "types.mailing_channels.singular": "Mailing Kanal",
        "types.mailing_channels.plural": "Mailing Kanäle",
        "types.mailing_deliverable.singular": "Mailing Zustellung",
        "types.mailing_deliverable.plural": "Mailing Zustellungen",
        "types.mailing_lists.singular": "Mailing Liste",
        "types.mailing_lists.plural": "Mailing Listen",
        "types.mailing_sent.singular": "Gesendetes Mailing",
        "types.mailing_sent.plural": "Gesendetes Mailings",
        "types.messages.singular": "Nachricht",
        "types.messages.plural": "Nachrichten",
        "types.notes.singular": "Notiz",
        "types.notes.plural": "Notizen",
        "types.notifications.singular": "Benachrichtigung",
        "types.notifications.plural": "Benachrichtigungen",
        "types.optins.singular": "Opt-In",
        "types.optins.plural": "Opt-Ins",
        "types.orders.singular": "Bestellung",
        "types.orders.plural": "Bestellungen",
        "types.permissions.singular": "Berechtigung",
        "types.permissions.plural": "Berechtigungen",
        "types.pricezones.singular": "Preis Zone",
        "types.pricezones.plural": "Preis Zonen",
        "types.products.singular": "Produkt",
        "types.products.plural": "Produkte",
        "types.datatemplates.singular": "Daten Vorlage",
        "types.datatemplates.plural": "Daten Vorlagen",
        "types.projects.singular": "Projekt",
        "types.projects.plural": "Projekte",
        "types.resellers.singular": "Reseller",
        "types.resellers.plural": "Resellers",
        "types.roles.singular": "Rolle",
        "types.roles.plural": "Rollen",
        "types.servicetokens.singular": "Servicetoken",
        "types.servicetokens.plural": "Servicetoken",
        "types.shoppingcarts.singular": "Warenkorb",
        "types.shoppingcarts.plural": "Warenkörbe",
        "types.subscriptions.singular": "Abonnement",
        "types.subscriptions.plural": "Abonnements",
        "types.suppliers.singular": "Zulieferer",
        "types.suppliers.plural": "Zulieferer",
        "types.tasks.singular": "Aufgabe",
        "types.tasks.plural": "Aufgaben",
        "types.translations.singular": "Übersetzung",
        "types.translations.plural": "Übersetzungen",
        "types.todos.singular": "Aufgabe",
        "types.todos.plural": "Aufgaben",
        "types.todotemplates.singular": "Aufgabenvorlage",
        "types.todotemplates.plural": "Aufgabenvorlagen",
        "types.users.singular": "Backoffice Benutzer",
        "types.users.plural": "Backoffice Benutzer",
        "types.visitors.singular": "Besucher",
        "types.visitors.plural": "Besucher",
        "types.visitorevents.singular": "Besucher Event",
        "types.visitorevents.plural": "Besucherevents",
        "types.printerconfigurations.singular": "Drucker Konfiguration",
        "types.printerconfigurations.plural": "Drucker Konfigurationen",
        "types.apps.singular": "App",
        "types.apps.plural": "Apps",
        "types.workflows_executions.singular": "Workflow Ausführung",
        "types.workflows_executions.plural": "Workflow Ausführungen",
        "types.workflows.singular": "Workflow",
        "types.workflows.plural": "Workflows",
        "types.worklogs.singular": "Arbeitsprotokoll",
        "types.worklogs.plural": "Arbeitsprotokolle",
        "types.pdftemplates.singular": "PDF Vorlage",
        "types.pdftemplates.plural": "PDF Vorlagen"
    };
}
exports.common_de_de = common_de_de;
